import DeleteDialog from "./DeleteDialog";
import SuccessDialog from "./SuccessDialog";
import ClassesTable from "./ClassesTable";
import { useClassesInfo } from "../hooks/useClassesInfo";

const ClassesInfo = () => {
  const {
    state: { appointments, clubNames, deleteDialog, cancelSuccessDialog, selectedClass, userName },
    actions: {
      setDeleteDialog,
      handleConfirmDelete,
      handleCancelSuccessClose,
      onClickDeleteClasses,
    },
  } = useClassesInfo();

  return (
    <>
      <DeleteDialog
        isOpen={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        onConfirm={handleConfirmDelete}
      />
      <SuccessDialog
        isOpen={cancelSuccessDialog}
        onClose={handleCancelSuccessClose}
        selectedClass={selectedClass}
        clubNames={clubNames}
        userName={userName}
      />
      <ClassesTable
        appointments={appointments}
        clubNames={clubNames}
        userName={userName}
        onClickDeleteClasses={onClickDeleteClasses}
      />
    </>
  );
};

export default ClassesInfo;
